import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const isFormValid = email.trim() !== "" && password.trim() !== "";

  const backendUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await fetch(`${backendUrl}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        // Store auth state in localStorage
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("userId", data.user_id?.toString() || "");
        localStorage.setItem("userEmail", email);

        // Redirect to main app
        navigate("/");
      } else {
        setError(data.message || "Invalid email or password");
      }
    } catch (err) {
      setError("Login failed. Please try again.");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-form-wrapper">
          <div className="login-logo">
            <span className="login-logo-text">Vamoos Studio</span>
          </div>
          <h1 className="login-title">Log in</h1>

          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="login-error">{error}</div>}

            <div className="login-input-wrapper">
              <label htmlFor="email" className="login-label">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="login-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>

            <div className="login-input-wrapper">
              <label htmlFor="password" className="login-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              className={`login-button ${
                isFormValid ? "login-button-active" : ""
              }`}
              disabled={isLoading || !isFormValid}
            >
              {isLoading ? "LOGGING IN..." : "LOG IN"}
            </button>
          </form>

          <div className="login-contact">
            <p>
              If you have questions email us at{" "}
              <a href="mailto:support@vamoos.com" className="contact-link">
                support@vamoos.com
              </a>
            </p>
            <p>
              or call us at{" "}
              <span className="phone-numbers">(UK) 0203 474 0512</span> or{" "}
              <span className="phone-numbers">(US) 213 808 6027</span>
            </p>
            <p>
              For more detail go to{" "}
              <a
                href="https://www.vamoos.com"
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.vamoos.com
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-image-overlay">
          <div className="login-promo-text">
            Vamoos Studio - Create custom applications for your travel business
            using AI-powered chat interface. Build complete apps with
            itineraries, weather, maps and offline access in minutes.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
